module.exports = __webpack_public_path__ + "static/media/mock.b94950ca.snippers";


//////////////////
// WEBPACK FOOTER
// ./src/routes/project/components/snippers/mock.snippers
// module id = 1248
// module chunks = 0